"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONVERSATIONS_INTERACT = exports.CONVERSATIONS_MULTI_INBOX = exports.CONTACT_LISTS_ACCESS = exports.TICKETS_SCOPE = exports.FEEDBACK_SCOPE = exports.SNIPPETS_ACCESS = exports.SERVICE_ACCESS = exports.CONVERSATIONS_NO_BRANDING = exports.CONVERSATIONS_ROUTING = exports.CONVERSATIONS_ADMIN = exports.CONVERSATIONS_ACCESS = exports.BOTS_WRITE = void 0;
var BOTS_WRITE = 'bots-write';
exports.BOTS_WRITE = BOTS_WRITE;
var CONVERSATIONS_ACCESS = 'conversations-access';
exports.CONVERSATIONS_ACCESS = CONVERSATIONS_ACCESS;
var CONVERSATIONS_ADMIN = 'conversations-admin';
/**
 * Users can be added to a routing pool (round-robin) only
 * if they have `conversations-routing`
 */

exports.CONVERSATIONS_ADMIN = CONVERSATIONS_ADMIN;
var CONVERSATIONS_ROUTING = 'conversations-routing';
exports.CONVERSATIONS_ROUTING = CONVERSATIONS_ROUTING;
var CONVERSATIONS_NO_BRANDING = 'conversations-no-branding';
exports.CONVERSATIONS_NO_BRANDING = CONVERSATIONS_NO_BRANDING;
var SERVICE_ACCESS = 'service-access';
exports.SERVICE_ACCESS = SERVICE_ACCESS;
var SNIPPETS_ACCESS = 'snippets-access';
exports.SNIPPETS_ACCESS = SNIPPETS_ACCESS;
var FEEDBACK_SCOPE = 'service-feedback-access';
exports.FEEDBACK_SCOPE = FEEDBACK_SCOPE;
var TICKETS_SCOPE = 'tickets-access';
exports.TICKETS_SCOPE = TICKETS_SCOPE;
var CONTACT_LISTS_ACCESS = 'contacts-lists-access';
exports.CONTACT_LISTS_ACCESS = CONTACT_LISTS_ACCESS;
var CONVERSATIONS_MULTI_INBOX = 'conversations-multi-inbox';
exports.CONVERSATIONS_MULTI_INBOX = CONVERSATIONS_MULTI_INBOX;
var CONVERSATIONS_INTERACT = 'conversations-interact';
exports.CONVERSATIONS_INTERACT = CONVERSATIONS_INTERACT;